import React from "react";

function RequiredDot(): JSX.Element {
  return (
    <div className="flex ml-1 mt-1" role="img" aria-label="Required">
      <svg
        width="8"
        height="8"
        className="fill-current text-red-500"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="4" cy="4" r="4" />
      </svg>
    </div>
  );
}

export default RequiredDot;
